import SearchFilter from '@components/ui/search-filter/search-filter';

import { useUrlFilter } from '@/hooks';

export const PrePurchaseListFilters = () => {
    const { setSearchText } = useUrlFilter();

    return (
        <div>
            <SearchFilter
                placeholder={'pre purchase'}
                onChangeSearch={(e) => setSearchText(e.target.value)}
            />
        </div>
    );
};

PrePurchaseListFilters.displayName = 'PrePurchaseListFilters';
